import api from "../../api";
import { getVisibility, NAConverter } from "../../utils";
import { collectionSubAdapter } from "../collection/adapter";
import galleryAdapter from '../gallery/adapter'
import systemAdapter from '../system/adapter'
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/id'

const subAdapter = {
  gallery: galleryAdapter
}

const adapter = {
  formToRequestBody(input){
    let output = {}

    if(input){
      const {
        title_en,
        title_id,
        content_en,
        content_id,
        categories = [],
        suitable = [],
        approach = [],
        issue = [],
        tags = [],
        gallery = [],
        submission
      } = input

      output = {
        judul_artikel: [title_id, title_en],
        deskripsi_pendek: [NAConverter(content_id), NAConverter(content_en)],
        deskripsi_panjang: [NAConverter(content_id), NAConverter(content_en)],
        typeAudience: suitable.map(s => s.value),
        blogsTag: tags.map(t => t.value),
        kategoriArtikel: categories ? categories : [],
        typeApproach: approach.map(s => s.value),
        typeIssues: issue.map(s => s.value),
        blogsGalleries: subAdapter.gallery.formToRequestBody(gallery),
        blogsFiles: [],
        submission,
        type_visibility: 1,
        type_sensitivity: 1,
        vsb_judul_artikel: 1,
        vsb_thumbnail: 1,
        vsb_main_image: 1,
        vsb_kategori_artikel: 1,
        vsb_deskripsi_pendek: 1,
        vsb_deskripsi_panjang: 1,
        vsb_type_audience: 1,
        vsb_type_approach: 1,
        vsb_type_issues: 1,
      };
    }

    return output
  },
  responseBodyToRender(input){
    let output = {}

    if(input){
      const {
        artikelId,
        blogId,
        imgThumbnail,
        imgMainImage,
        kategoriArtikel,
        judulArtikel,
        myOrganisasi,
        deskripsiPendek,
        datePublish,
        blogsGalleries,
        totalLikes,
        totalBookmarks,
        listLike = [],
        listBookmark = [],
        submission,
        likedByMe,
        bookmarkByMe,
        typeApproach = [],
        typeIssues = [],
        typeAudience = []
      } = input

      let category_id
      let category = {
        en: 'uncategorized',
        id: 'uncategorized'
      }
      let categories_rendered = ''

      if(kategoriArtikel && kategoriArtikel[0] && kategoriArtikel[0].nama){
        category_id = kategoriArtikel[0].id
        category = {
          en: kategoriArtikel[0].nama[1],
          id: kategoriArtikel[0].nama[0]
        }
        categories_rendered = systemAdapter.responseBodyArrayToBilingualObject(kategoriArtikel)
      }

      const organization_id = myOrganisasi ? myOrganisasi.organisasiId : undefined
      const organization = myOrganisasi ? myOrganisasi.namaOrganisasi : 'Default'

      const visibility_field_blacklist = [
        'vsbDeskripsiPendek',
        'vsbTag',
        'vsbComments'
      ]
      const visibility_id_only = getVisibility(input, visibility_field_blacklist).visibilityIdOnly
      const is_all_public = getVisibility(input).isAllPublic
      const is_private = getVisibility(input).isPrivate

      const minute_read = Math.ceil(deskripsiPendek ? (deskripsiPendek[0].split(' ').length/200) : 1)

      output = {
        id: blogId ? blogId : artikelId,
        is_all_public,
        is_private,
        image: api.base_image + imgMainImage,
        thumbnail: api.base_image + imgThumbnail,
        category_id,
        category,
        categories_rendered,
        organization_id,
        organization,
        organization_logo: api.base_image+myOrganisasi?.imgLogoOrganisasi,
        title: {
          en: judulArtikel ? judulArtikel[1] : '-',
          id: judulArtikel ? judulArtikel[0] : '-',
        },
        excerpt: {
          en: deskripsiPendek ? deskripsiPendek[1] : '-',
          id: deskripsiPendek ? deskripsiPendek[0] : '-'
        },
        content: {
          en: deskripsiPendek ? deskripsiPendek[1] : '-',
          id: deskripsiPendek ? deskripsiPendek[0] : '-'
        },
        featured: false,
        date: datePublish,
        date_by_language: {
          en: dayjs(datePublish).format('MMM DD, YYYY [at] HH:mm a'),
          id: dayjs(datePublish).locale('id').format('DD MMMM YYYY [pukul] HH:mm')
        },
        minute_read,
        gallery: subAdapter.gallery.responseBodyToRender(blogsGalleries),

        total_likes: totalLikes,
        total_bookmarks: totalBookmarks,
        likes: listLike.map(l => collectionSubAdapter.like.responseBodyToRender(l)),
        bookmarks: listBookmark.map(l => collectionSubAdapter.like.responseBodyToRender(l)),
        submission,

        visibility_id_only,

        liked: likedByMe,
        bookmarked: bookmarkByMe,
        approach_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeApproach),
        issue_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeIssues),
        audience_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeAudience),
      };
    }

    return output
  }
}

export default adapter
